export const getUserType = (session: any): boolean => {
    const isHgc = !!session?.user?.roles?.isHgcConnex;

    if (typeof window !== 'undefined') {
        const stored = localStorage.getItem('is-hgc-user');
        if (session) {
            localStorage.setItem('is-hgc-user', String(isHgc));
            return isHgc;
        }
        return stored === 'true';
    }

    return isHgc;
};
